import { getFormValues, initialize } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import requestTransferReservation, {
  IReservationWasTransfered,
  reservationWasTransfered,
} from '../../../actions/bookingCalendar/event/transferReservation'
import { callFetch } from '../../../actions/fetch'
import { IFormAction } from '../../../actions/form/createFormActions'
import { requestSynchronization } from '../../../actions/synchronize/synchronize'
import {
  fireToastError,
  fireToastSuccess,
} from '../../../actions/toasts/fireToast'
import { ITransferFormValues } from '../../../containers/BookingCalendar/TransferReservationModal/TransferReservationForm'
import { database } from '../../../database'
import i18n from '../../../i18n'
import { IEvent } from '../../../models/Event'
import requestUpdate from '../../../models/Event/updateEvent'
import { addOffsetDate } from '../../../models/License/mappers/mapResponseToLicense'
import { UpdateLimitType } from '../../../models/Limit'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import { getCalendarId } from '../../../reducers/bookingCalendar/selectors/calendar'
import { getEventById } from '../../../reducers/bookingCalendar/selectors/events'
import fetchActionsName, { ActionNames } from '../../../utils/FetchActionsName'
import {
  LimitResponse,
  LimitType,
  loadLimits,
} from '../../userAccount/loadLimits'
import updateLimits from '../../userAccount/updateLimits'

function* transferEvent(action: IFormAction<ITransferFormValues>) {
  const formData = action.payload

  const response = yield* loadLimits(LimitType.Transfer)
  if (response === LimitResponse.Rejected) {
    yield Effects.put(requestTransferReservation.failure())
    return
  }

  const { eventData } = formData
  // type ReturnTransferEvent = IFetchAction<ReturnType<typeof requestTransfer>>

  try {
    // const actionNames = fetchActionsName(ActionNames.TransferEvent)
    // const [{ calendarId, service }]: [ReturnTransferEvent] = yield Effects.all([
    //   Effects.take(actionNames.output),
    //   Effects.put(
    //     callFetch(actionNames.input, actionNames.output, requestTransfer),
    //   ),
    // ])
    //

    //
    // const event: IEvent[] = yield Effects.call(
    //   service,
    //   formData.roomId,
    //   formData.eventId,
    //   formData.dateFrom,
    //   formData.dateTo,
    //   formData.eventData,
    //   calendarId,
    // )

    const ev: IEvent = yield Effects.select(getEventById(formData.eventId))

    const actionNamesUpdate = fetchActionsName(ActionNames.UpdateEvent)
    const serviceUpdate = yield Effects.all([
      Effects.take(actionNamesUpdate.output),
      Effects.put(
        callFetch(
          actionNamesUpdate.input,
          actionNamesUpdate.output,
          requestUpdate,
        ),
      ),
    ])

    const updatedEvent: IEvent[] = yield Effects.call(
      serviceUpdate[0].service,
      serviceUpdate[0].calendarId,
      formData.eventId,
      {
        ...eventData,
        dateFrom: formData.dateFrom,
        dateTo: formData.dateTo,
        roomId: formData.roomId,
      },
    )

    yield Effects.put(
      fireToastSuccess(
        i18n.t('z677_reservation_has_been_moved'),
        5000,
        'Main',
        'ReservationTransferSuccess',
      ),
    )

    yield Effects.put(requestTransferReservation.success())
    yield Effects.put(
      reservationWasTransfered(updatedEvent[0], formData.roomId, ev.roomId),
    )
    yield* updateLimits(UpdateLimitType.Transfer)
  } catch (e) {
    if (e.message === '409') {
      yield Effects.put(requestSynchronization())
      yield Effects.put(
        fireToastError(i18n.t('reservation_reserved_date_error')),
      )

      const values = yield Effects.select(getFormValues('transferForm'))
      yield Effects.put(
        initialize('transferForm', { ...values, roomId: undefined }),
      )
    } else if (e.message === 'Period is not free') {
      yield put(
        fireToastError(
          i18n.t('z677_period_is_not_free'),
          undefined,
          undefined,
          'reservation_update_error',
        ),
      )
    } else {
      yield Effects.put(fireToastError(i18n.t('cannot_transfer_event')))
    }
    yield Effects.put(requestTransferReservation.failure())
  }
}

function* updateEventInDb(action: IReservationWasTransfered) {
  const calendarId = yield Effects.select(getCalendarId)

  const event = {
    ...action.event,
    bookingPrice: null,
    calendarId,
    deposit: null,
    finishDate: addOffsetDate(action.event.finishDate).getTime(),
    localTax: null,
    paymentOnPlace: null,
    price: null,
    pricePerDay: null,
    provision: null,
    savedColor: action.event.customColor
      ? action.event.customColor.rgb().toString()
      : null,
    startDate: addOffsetDate(action.event.startDate).getTime(),
  }

  yield database.events.update(action.event.id, event)
}

export default function* () {
  yield Effects.takeLatest(requestTransferReservation.TRIGGER, transferEvent)
  yield Effects.takeEvery(
    EventActions.ReservationWasTransfered,
    updateEventInDb,
  )
}
